<template>
  <page-wrap>
    <layout v-loading="isLoading" :isEmpty="!partID" :messageEmpty="L10n('select-a-part')">
      <template v-slot:header>
        <h1 class="page-title">{{pageTitle}}</h1>
      </template>
      <template v-slot:tools>
        <top-panel
          v-model="partID"
          @onCameData="handleCameData"
        ></top-panel>
      </template>
      <template v-slot:content>
        <layout-scroll-content>
          <editor
            v-if="isShowEditor"
            :isStatusAvailable="isStatusAvailable"
            :key="partID"
            :partID="partID"
            :partNumber="dataPart.partNumber"
            :isLoading.sync="isLoading"
          ></editor>
        </layout-scroll-content>
      </template>
    </layout>
  </page-wrap>
</template>

<script>
import { routeEditLogic } from '@/mixins/modals'
export default {
  name: 'QuickRFQPart',
  mixins: [ routeEditLogic ],
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanel'),
    'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'top-panel': () => import(/* webpackChunkName: 'QuickRFQPart' */ './TopPanel.vue'),
    'editor': () => import(/* webpackChunkName: 'QuickRFQPart' */ './Editor')
  },
  props: {
    isStatusAvailable: {
      type: Boolean,
      default: true
    },
    config: {
      type: Object,
      default: () => ({ id: 'quick-rfq-part' })
    }
  },
  data () {
    return {
      isLoading: false,
      dataPart: {}
    }
  },
  computed: {
    partID: {
      get () {
        const value = this.mixValue ? parseInt(this.mixValue) : null
        return isNaN(value) ? null : value
      },
      set (value) {
        this.mixSetRoute({ value })
      }
    },
    isShowEditor () {
      return this.dataPart && Object.keys(this.dataPart).length > 0
    },
    pageTitle () {
      return this.L10n(this.$route.meta.label)
    }
  },
  methods: {
    handleCameData (value) {
      this.dataPart = value || {}
    },
    // MIX
    mixHookState ({ value, state }) {
    },
    mixHookReset () {
    }
  }
}
</script>
